<script>
    import { querystring } from 'svelte-spa-router';
    import { invoices_store } from '../../stores.js';
    import { onMount } from 'svelte';
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import Header from "../header.svelte";
    import { push } from 'svelte-spa-router';
    import { formatDateAndTime, sort_functions } from '../../utils/format.js';


    let working_invoices = [];
    let is_busy = false;
    let page_filter = "all";
    let is_mounted = false;
    let date_value = '';
    function process_params(qs) {
        setTimeout(()=>{window.scrollTo(0, 0);}, 100);
        const params = new URLSearchParams(qs);
        if(params.has('filter')){
            page_filter = params.get('filter');
        }
        return page_filter.replaceAll('_', ' ');
    }

    $: content_title = "Invoices - " + process_params($querystring);

    onMount(async () => {
        setTimeout(()=>{ is_mounted = true; }, 250);
    });

    invoices_store.subscribe(value => {
        const invoices = value;
        let _working_invoices = [];
        for (let i = 0; i < invoices.length; i ++) {
            const invoice = invoices[i];
            _working_invoices.push({
                'id': invoice.invoice_number.toUpperCase(),
                'c': `<a sortValue='${invoice.client}' href='/#/User_Review?uid=${invoice.hid}'>${invoice.client}</a>`,
                'p': `${invoice.price}`,
                'j': `${invoice.address}, ${invoice.city}, ${invoice.state}`,
                'd': formatDateAndTime(invoice.date),
                'dd': formatDateAndTime(invoice.date).split(' ')[0]
            });
        }
        _working_invoices.sort((a, b) => {
            if (new Date(a.dd) < new Date(b.dd)) return 1;
            if (new Date(a.dd) > new Date(b.dd)) return -1;
            return 0;
        });
        working_invoices = _working_invoices;
    });

    let table_header_config = [
        {'t': 'Invoice #', 'fm': 'id', 'a': true},
        {'t': 'Client', 'fm': 'c', 'a': true},
        {'t': 'Price', 'fm': 'p', 'a': true},
        {'t': 'Job', 'fm': 'j', 'a': true},
        {'t': 'Date', 'fm': 'd', 'a': true},
    ];


    let show_items = [
        {"id": "show", "i": "fas fa-eye", "s": "color: #1c54b2;", "f": (id) => { push("#/Invoice_Review?iid=" + id.toLowerCase()); }},
        // {"id": "edit", "i": "fas fa-edit", "s": "color: #ff9800;", "f": (id) => {push("#/Invoice_Edit?iid=" + id); }},
    ];
    let action_items = [
        {"id": "delete", "i": "fas fa-trash-alt", "s": "color: #ab003c;", "f": (id) => {console.log(`whould be deleting id: ${id}`);}}
    ];
    
    let field_formats = {
        "p": (p) => {
            if (typeof(p) === "string" && !p.startsWith("$")) {
                var formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD',});
                return formatter.format(parseFloat(p));
            } else {
                return p;
            }
        }
    };

    let field_styles = {
        "p": "text-align: right;"
    }
</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />
<div class="contentholder">    
    <div class="section">
        <div class="invoicetableholder">
            <ResponsiveTable
                table_data={working_invoices}
                field_formats={field_formats}
                field_styles={field_styles}
                sort_functions={sort_functions}
                num_per_page={100}
                show_date_range={true}
                date_filter_param='dd'
                action_items_title='Actions'
                refresh_action='invoices'
                bind:is_busy={is_busy}
                bind:show_items={show_items}
                bind:action_items={action_items}
                bind:table_header_config={table_header_config}
                bind:date_value={date_value}
                bind:total_items={working_invoices.length}
            />
        </div>
    </div>
</div>

<style>
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .row{
        padding: 0px;
        margin: 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    .contentholder {
        padding: 0px;
    }
    :global(.flatpickr-input) {
        /* background-color: #ff9100; */
        /* color: white; */
        width: 250px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 0px;
            width: 100%;
        }
        .row{
            padding: 0px;
            margin: 0px;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }

        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        :global(.flatpickr-input) {
            /* background-color: #ff9100; */
            /* color: white; */
            width: 100%;
        }
    }
</style>